<template>
  <div class="Listing">

    <div class="modile-helper" @click="open_new_window()">
      <div class="info-message">
        <h3>{{ $t('list.title_mobile_helper') }}</h3>
        <p>{{ $t('list.description_mobile_helper') }}</p>
      </div>
    </div>

    <div class="Filters" v-if="show_sort === true || show_category === true">
      <div class="PriceFilterContainer">
          <sort-by-price @input="update_sort_order" v-if="show_sort === true"></sort-by-price>
      </div>

      <div class="CategoryFilterContainer">
          <filter-by-category v-if="categories.length > 0 && show_category" @input="update_category" :categories="categories" :category_id="selected_category"></filter-by-category>
      </div>
    </div>

    <ul class="Product-List">
      <template v-for="product in products">
        <product :key="product.product_id" :moduleId="module_id" :apiUrl="api_url" :product="product" :currency="currency"></product>
      </template>
    </ul>

    <!-- <template v-for="row in chunkProducts">

        <div class="Product-Row" v-if="design_type == 1">
            <transition-group name="flip-list" tag="div">
                <template v-for="product in row">
                    <product :key="product.product_id" :moduleId="module_id" :apiUrl="api_url" :product="product" :currency="currency"></product>
                </template>
            </transition-group>
        </div>

        <div v-if="design_type == 2">
            <type2 :key="product.product_id" :moduleId="module_id" :apiUrl="api_url" :product="product" :currency="currency" v-for="product in row"></type2>
        </div>

        <div v-if="design_type == 3">
            <type3 :key="product.product_id" :moduleId="module_id" :apiUrl="api_url" :product="product" :currency="currency" v-for="product in row"></type3>
        </div>
    </template> -->
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Product from './_partials/product.vue';
  import Type2 from './_partials/type2.vue';
  import Type3 from './_partials/type3.vue';
  import SortByPrice from './_partials/sort.vue';
  import FilterByCategory from './_partials/filter-by-category.vue';
  import utilities from '../../api/utilities.js';

  export default {
    data () {
      return {
        order: '',
      };
    },

    components: {
      Product,
      Type2,
      Type3,
      SortByPrice,
      FilterByCategory
    },

    computed: {
      ...mapGetters([
        'products',
        'categories',
        'getCategoriesWithEmpty',
        'active_module'
      ]),

      show_sort () {
        return this.$store.state.Module.active_module.settings.module.show_sort;
      },

      show_category () {
        return this.$store.state.Module.active_module.settings.module.show_category;
      },

      module_id () {
        return this.$route.params.module_id;
      },

      selected_category () {
        return this.$route.query.category_id;
      },

      currency () {
        return this.$store.state.Module.active_module.currency;
      },

      count () {
        return this.$store.state.count;
      },

      api_url () {
        return utilities.apiURL();
        // return 'https://api.sanalposentegrasyonu.com/';
      },

      design_type () {
        return this.active_module.settings.design.type || 1;
      },

      chunkProducts () {
        // [0, 1, 2, 3, 4]
        // (0,3) (3,6)
        let length = this.products.length;
        let chunkedArray = [];
        let number = 4;
        // let w = window.innerWidth;
        if (this.width < 640) {
          number = 2;
        } else if (this.width < 765) {
          number = 1;
        }

        for (let begin = 0; begin < length; begin += number) {
          chunkedArray.push(this.products.slice(begin, begin + number));
        }
        return chunkedArray;
      }
    },

    methods: {
      ...mapActions([
        'init_module',
        'init_vendor_id',
        'list_products',
        'init_categories',
        'select_category_id',
        'select_sort_order',
      ]),

      update_category (val) {
        console.log('NEW CATEGORY: ', val);
        this.select_category_id({category_id: val});
        this.list_products({ module_id: this.$route.params.module_id });
      },

      update_sort_order (val) {
        console.log('NEW CATEGORY: ', val);
        this.select_sort_order({sort_order: val});
        this.list_products({ module_id: this.$route.params.module_id });
      },

      open_new_window () {
        var win = window.open(window.location.href, '_blank');
        win.focus();
      }
    },

    created () {
      // console.log('Created List object.');
      // this.init_categories({
      //   module_id: this.$route.params.module_id
      // });

      // this.init_module(this.$route.params.module_id);
      // this.list_products(
      //   {
      //     module_id: this.$route.params.module_id,
      //     category_id: parseInt(this.$route.query.category_id),
      //   }
      // );
      // this.init_vendor_id(this.$route.params.vendor_id);
    }
  };
</script>

<style>
  .Filters {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0;
  }

  .Listing {
    display: flex;
    flex-direction: column;
  }

  .Product-Row {
    display: flex;
  }

  .Product-List {
    padding: 0;
    margin: 0;
    max-width: 100%;

    list-style: none;

    display: flex;
    flex-wrap: wrap;
  }


  .modile-helper {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Roboto';
    font-weight: 300;
    padding: 10px 10%;
    display: none;
  }

  .info-message {
    margin-top: 20px;
    border: 2px solid #CF4647;
    background-color: #CF4647;
    color: #fff;
    padding: 6px 10px 2px;
  }

  .info-message h3 {
    margin: 4px 0px;
  }

  @media screen and (max-width: 575px) {
    .Filters {
      display: block;
    }

    .Product-List {
      display: block;
    }
  }

  @media screen and (max-width: 300px) {
    .modile-helper {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// List.vue?cbd45752